import * as actionTypes from "./actionTypes";

export const actions = {
  getHomePage: () => ({ type: actionTypes.GET_HOMEPAGE_REQ }),
  getHomePageSuccess: (payload) => ({
    type: actionTypes.GET_HOMEPAGE_SUCCESS,
    payload,
  }),
  getHomePageFail: (error) => ({ type: actionTypes.GET_HOMEPAGE_FAIL, error }),
};

const initialState = {
  data: {},
  error: {},
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_HOMEPAGE_REQ:
      return state;
    case actionTypes.GET_HOMEPAGE_SUCCESS:
      return {
        error: {},
        data: { ...action.payload },
      };
    case actionTypes.GET_HOMEPAGE_FAIL:
      return {
        data: {},
        erorr: { ...action.payload },
      };
    default:
      return state;
  }
};
reducer.initialState = initialState;
export default reducer;
